import { RowCrudStatus } from "../../common/types";
import {
  TenantStatus,
  TenantStatusCreateMutationVariables,
  TenantStatusUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type TenantStatusValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  description_es: string;
  description_en: string;
  description_pt: string;
  blocksAccess: boolean;
};

export type TenantStatusErrorsType = {
  name?: { message: string; fieldLabel: string };
  description_es?: { message: string; fieldLabel: string };
  description_en?: { message: string; fieldLabel: string };
  description_pt?: { message: string; fieldLabel: string };
  blocksAccess?: { message: string; fieldLabel: string };
};

export function TenantStatusValuesInit(): TenantStatusValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    description_es: "",
    description_en: "",
    description_pt: "",
    blocksAccess: false,
  };
}

export type TenantStatusType = TenantStatus | TenantStatusValuesType;

export function tenantStatusDisplayId(
  source: Partial<TenantStatus>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getTenantStatusValues(
  source: TenantStatusType,
  _langStore: LangStore,
  _duplicated: boolean = false
): TenantStatusValuesType {
  const entityValues = TenantStatusValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : tenantStatusDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.description_es = source.description_es || "";
  entityValues.description_en = source.description_en || "";
  entityValues.description_pt = source.description_pt || "";
  entityValues.blocksAccess = source.blocksAccess || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getTenantStatusUpdateVariables(
  values: TenantStatusValuesType
): TenantStatusUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    description_es: blankToNull(values.description_es),
    description_en: blankToNull(values.description_en),
    description_pt: blankToNull(values.description_pt),
    blocksAccess: values.blocksAccess,
  };
}

export function getTenantStatusCreateVariables(
  values: TenantStatusValuesType
): TenantStatusCreateMutationVariables {
  return {
    name: values.name,
    description_es: blankToNull(values.description_es),
    description_en: blankToNull(values.description_en),
    description_pt: blankToNull(values.description_pt),
    blocksAccess: values.blocksAccess,
  };
}
